/**
 * Default location configuration
 * Used as fallback when user location is not available
 */

export interface DefaultLocation {
  city: string;
  state: string;
  latitude: number;
  longitude: number;
}

/**
 * Default location: Bloomington, IN
 * Coordinates approximate to downtown Bloomington
 */
export const DEFAULT_LOCATION: DefaultLocation = {
  city: 'Bloomington',
  state: 'IN',
  latitude: 39.1653,
  longitude: -86.5264,
};
